import React from 'react';
import styles from './DataCompleteness.module.scss';

interface Props {
  Model?: any; // Data from backend
  PageData?: any;
}

const DataCompleteness = ({ Model, PageData }: Props) => {
  const percentValue: string =
    Model.ContactDetails.DataCompletenessPercent + ',' + '100';
  return (
    <div>
      <div className="Grid Grid--white GridWhite--smFull Grid--itemsAlignMiddle Grid--alignCenter Grid--gutterH">
        <div className="Grid-cell u-size1of2 u-lg-size1of3">
          <dl className="Repaymentlist Repaymentlist-boldDD Customerdetails-customerList data-hj-suppress">
            <dt>{PageData?.DebtReferenceLabel}</dt>
            <dd>{Model.CustomerInformation.DebtReference}</dd>

            <dt>{PageData?.NameLabel}</dt>
            <dd>{Model.CustomerInformation.FirstName}</dd>

            <dt>{PageData?.SurnameLabel}</dt>
            <dd>{Model.CustomerInformation.LastName}</dd>
          </dl>
        </div>
        <div className="Grid-cell u-size1of2 u-lg-size1of3">
          <div className="Circlechart">
            <svg
              className="circle-chart"
              viewBox="0 0 33.83098862 33.83098862"
              width="200"
              height="200"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                className="circle-chart__background"
                stroke="#e87722"
                stroke-width="2"
                fill="none"
                cx="16.91549431"
                cy="16.91549431"
                r="15.91549431"
              />
              <circle
                className="circle-chart__circle"
                stroke="#3a913f"
                stroke-width="2"
                strokeDasharray={percentValue}
                fill="none"
                cx="16.91549431"
                cy="16.91549431"
                r="15.91549431"
              />
              <g className="circle-chart__info">
                <text
                  className="circle-chart__top"
                  x="16.91549431"
                  y="11.5"
                  alignment-baseline="central"
                  text-anchor="middle"
                  font-size="2"
                >
                  {PageData.DataCompletenessFirstLabel}
                </text>
                <text
                  className="Circlechart-text--percent"
                  x="16.91549431"
                  y="17.5"
                  alignment-baseline="central"
                  text-anchor="middle"
                  font-size="8"
                >
                  {Model.ContactDetails.DataCompletenessPercent} %
                </text>
                <text
                  className="Circlechart-text--subline"
                  x="16.91549431"
                  y="23"
                  alignment-baseline="central"
                  text-anchor="middle"
                  font-size="2.5"
                >
                  {PageData?.DataCompletenessSecondLabel}
                </text>
              </g>
            </svg>
          </div>
        </div>
        <div className="Grid-cell u-lg-size1of3">
          <div className="Customerdetails-note">
            <p>
              <span className="CustomerdetailsNote-heading">
                {PageData.ContactInfoTextHeading}
              </span>
              <span
                dangerouslySetInnerHTML={{
                  __html: PageData.ContactInfoText,
                }}
              />
            </p>
          </div>
        </div>
      </div>
      {Model.ContactDetails.HasDataCompletenessPercentValue &&
        Model.ContactDetails.DataCompletenessPercent < 100 && (
          <div className="u-hidden u-lg-flex Grid Grid--white Grid--white--noPadding Grid--alignCenter Grid--gutterH">
            <div className="Grid-cell">
              <div className="Completeandupdate Completeandupdate--center">
                <p>
                  {PageData.DataCompletenessUpdateFirstLabel}{' '}
                  <span className="Completeandupdate-level Completeandupdate-level--medium">
                    {Model.ContactDetails.DataCompletenessPercent} %{' '}
                    {PageData.DataCompletenessPercentLabel}
                  </span>
                  <span className="u-hidden u-md-inline">
                    {PageData.DataCompletenessUpdateLastLabel}
                  </span>
                </p>
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

export default DataCompleteness;
